import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Role } from '../../domain/models/role.model';
import { RoleOption } from '../../domain/models/role-option.model';
import { IRolesRepository } from '../../domain/repositories/roles.repository';
import { RolesRemoteDatasource } from '../datasources/remote/roles.remote-datasource';
import { RoleMapper } from '../mappers/role.mapper';

@Injectable()
export class RolesRepositoryImpl implements IRolesRepository {
  private readonly datasource = inject(RolesRemoteDatasource);
  private readonly mapper = inject(RoleMapper);

  public listManagedRoles(): Observable<readonly RoleOption[]> {
    return this.datasource.list().pipe(
      map((dtos) => this.mapper.toManagedRoleOptions(dtos)),
    );
  }

  public listRoles(): Observable<readonly Role[]> {
    return this.datasource.list().pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toRole(dto))),
    );
  }

  public setPermissions(roleId: number, permissions: readonly string[]): Observable<Role> {
    return this.datasource.setPermissions(roleId, permissions).pipe(
      map((dto) => this.mapper.toRole(dto)),
    );
  }
}
